import { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { domAnimation, LazyMotion, MotionConfig } from 'motion/react';
import { ThemeProvider } from 'next-themes';
import { Toaster } from 'sonner';
import Layout from './layout/Layout';
import AppErrorAlert from './components/AppErrorAlert';
import ScrollToTop from './components/ScrollToTop';
import { useProductsStore } from './state/useProductsStore';
import { useSettingsStore } from './state/useSettingsStore';
import './config/i18n.config';
import './index.css';

const helmetContext = {};

const App = () => {
  useEffect(() => {
    useProductsStore.getState().fetchProducts();
    useSettingsStore.getState().fetchSettings();
  }, []);

  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <HelmetProvider context={helmetContext}>
        <MotionConfig reducedMotion="user">
          <LazyMotion features={domAnimation} strict>
            <BrowserRouter>
              <Toaster richColors position="top-right" />
              <AppErrorAlert />
              <ScrollToTop />
              <Layout />
            </BrowserRouter>
          </LazyMotion>
        </MotionConfig>
      </HelmetProvider>
    </ThemeProvider>
  );
};

export default App;
